import React from "react";
import { useForm } from "react-hook-form";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import Button from "../../components/ui/Button";

const ContactForm = ({ onNext, defaultValues }) => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: defaultValues || {},
  });

  const countries = [
    "Afghanistan",
    "Albania",
    "Algeria",
    "Australia",
    "Canada",
    "France",
    "Germany",
    "India",
    "Japan",
    "United Kingdom",
    "United States",
  ]; // Add more as needed

  const inputStyle =
    "w-full px-4 py-3 rounded-xl border text-[16px] md:text-[20px] 2xl:text-[24px] border-[#183076] focus:outline-none focus:ring-2 focus:ring-[#183076] transition-all placeholder:text-[#183076]/50 bg-white";
  const labelStyle =
    "font-bold text-[#183076] text-[16px] md:text-[20px] 2xl:text-[24px]";
  const errorStyle = "text-red-500 text-sm mt-1 font-semibold";

  return (
    <section className="max-w-[1800px] mx-auto px-4">
      <div className="bg-white p-8 md:p-12 rounded-[2rem] shadow-sm border border-[#183076]">
        <div className="mb-8">
          <h2 className="text-[20px] md:text-[24px] 2xl:text-[30px] font-bold text-[#183076]">
            Contact Information
          </h2>
          <p className="text-[16px] md:text-[20px] 2xl:text-[24px] text-[#183076] mt-2 mb-[30px]">
            Foundation of trust for human subjects research
          </p>
        </div>

        <form onSubmit={handleSubmit(onNext)} className="space-y-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="flex flex-col gap-2">
              <label className={labelStyle}>Full Name *</label>
              <input
                {...register("fullName", { required: "Name is required" })}
                className={inputStyle}
                placeholder="Enter your name"
              />
              {errors.fullName && (
                <span className={errorStyle}>{errors.fullName.message}</span>
              )}
            </div>
            <div className="flex flex-col gap-2">
              <label className={labelStyle}>Email Address *</label>
              <input
                {...register("email", {
                  required: "Email is required",
                  pattern: { value: /^\S+@\S+$/i, message: "Invalid email" },
                })}
                type="email"
                className={inputStyle}
                placeholder="Enter Email Address"
              />
              {errors.email && (
                <span className={errorStyle}>{errors.email.message}</span>
              )}
            </div>
            <div className="flex flex-col gap-2">
              <label className={labelStyle}>Phone Number *</label>
              <PhoneInput
                country={"us"}
                value={watch("phone")}
                onChange={(val) => setValue("phone", val)}
                containerClass="!w-full"
                inputClass="!w-full !h-[55px] !rounded-xl !border-[#183076] !text-[18px]"
                buttonClass="!border-[#183076] !rounded-l-xl !bg-white"
              />
              {errors.phone && (
                <span className={errorStyle}>Phone is required</span>
              )}
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="flex flex-col gap-2">
              <label className={labelStyle}>Company / Institution *</label>
              <input
                {...register("institution", { required: "Required" })}
                className={inputStyle}
                placeholder="Enter Details"
              />
            </div>
            <div className="flex flex-col gap-2">
              <label className={labelStyle}>Department *</label>
              <input
                {...register("department", { required: "Required" })}
                className={inputStyle}
                placeholder="Enter Details"
              />
            </div>
            <div className="flex flex-col gap-2">
              <label className={labelStyle}>Country / Region *</label>
              <select
                {...register("country", { required: "Required" })}
                className={inputStyle}
              >
                <option value="">Select Country</option>
                {countries.map((c) => (
                  <option key={c} value={c}>
                    {c}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="flex justify-center pt-8">
            <Button
              type="submit"
              className="bg-[#183076] text-white px-12 md:px-20 py-3 rounded-full font-bold hover:bg-transparent hover:text-[#183076] border border-[#183076] transition-all"
            >
              Next
            </Button>
          </div>
        </form>
      </div>
    </section>
  );
};
export default ContactForm;
